import { DEFAULT_THEME_ID, getThemeById, THEME_STORAGE_KEY } from '@/config/theme'

function setVar(name, value) {
  document.documentElement.style.setProperty(name, value)
}

export function applyTheme(themeId) {
  const theme = getThemeById(themeId || DEFAULT_THEME_ID)
  const root = document.documentElement
  root.setAttribute('data-theme', theme.id)
  setVar('--hrs-primary', theme.primary)
  setVar('--hrs-primary-light', theme.primaryLight)
  setVar('--hrs-primary-dark', theme.primaryDark)
  setVar('--hrs-primary-hover', theme.primaryHover)
  setVar('--hrs-sidebar-from', theme.sidebarFrom)
  setVar('--hrs-sidebar-to', theme.sidebarTo)
  setVar('--hrs-sidebar-text', theme.sidebarText)
  setVar('--hrs-sidebar-active-bg', theme.sidebarActiveBg)
  setVar('--hrs-sidebar-active-text', theme.sidebarActiveText)
  setVar('--hrs-header-from', theme.headerFrom)
  setVar('--hrs-header-to', theme.headerTo)
  setVar('--hrs-layout-bg', theme.layoutBg)
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme.id)
  } catch (e) {
    /* ignore */
  }
  return theme
}

export function loadStoredTheme() {
  let id = DEFAULT_THEME_ID
  try {
    id = localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME_ID
  } catch (e) {
    /* ignore */
  }
  return applyTheme(id)
}

export function getStoredThemeId() {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME_ID
  } catch (e) {
    return DEFAULT_THEME_ID
  }
}
